import { apiClient } from './axiosInstance';

export const fetchProjectsFilterList = async () => {
  return await apiClient.get(`/projects/base/projects`);
};
